/* eslint-disable */
import gaAsync from "@/js/common/Domain/Service/gaAsync";

var UserSubscribe = Backbone.View.extend({
	validate: function() {
		var $formId = $("#emailSubscribeForm");

		$formId.validate({
			rules: {
				email: {
					required: true,
					email: true
				},
				useragreement: {
					required: true
				}
			},
			messages: {
				email: {
					required: "Введите ваш Email",
					email: "Введите правильный Email"
				},
				useragreement: {
					required: "Пожалуйста, примите соглашение"
				}
			},
			errorPlacement: function(error, element) {
				if(element.is(":checkbox")) {
					element.closest('label').after(error);
				} else {
					error.insertAfter(element);
				}
			}

		});
	},

	sendData: function() {
		var $formId = $("#emailSubscribeForm"),
			$errorElement,
			errorText = 'Произошла ошибка. Попробуйте использовать другой адрес электронной почты.';

		if ($formId.valid()) {


			var data = $formId.serialize();

			$.ajax({
				url: $formId.attr("action"),
				data: data,
				dataType: "json",

				beforeSend:function(){
					$formId.addClass("sending");
					$formId.removeClass("error");
				},

				success: function(response) {
					if(response.success) {
						$formId.removeClass("sending");
						$formId.addClass("success");
						gaAsync(function() {
							ga('send', 'event', 'Subscription', 'Subscription_success', 'http://travelata.ru/atlas/index/');
						});
					} else {
						$errorElement = $formId.find('input[name="email"]').parent().find('.error[for="email"]');
						$formId.removeClass('sending');

						if($errorElement.length) {
							$errorElement.text(errorText).show();
						} else {
							$errorElement = $('<label for="email" class="error">' + errorText + '</label>');
							$formId.find('input[name="email"]').after($errorElement);
						}

						$formId.find('input[name="email"]').addClass('error');
					}
				},

				error: function() {
					$formId.removeClass("sending");
					$formId.addClass("error");
				}

			})
		}
		return false;
	},

	initialize: function() {
		var $formId = $("#emailSubscribeForm");
		this.validate();
		$formId.submit(this.sendData);

		$("#resend").click(function(e){
			$formId.removeClass("error");
			return false;
		});
	}

});

export default UserSubscribe;